import { FieldPrefix } from './FieldPrefix'

export const FieldTel = ({ name, value, onChange, onInput, label, required = false, placeholder, error }) => {
  return (
    <FieldPrefix
      type="tel"
      name={name}
      value={value}
      required={required}
      onChange={onChange}
      onInput={onInput}
      label={label}
      placeholder={placeholder}
      prefix={{
        options: [
          {
            value: '+61',
            pattern: '^4\\d{2}[ \\-]?\\d{3}[ \\-]?\\d{3}$'
          }
        ]
      }}
      error={error}
    />
  )
}
